import { gql } from '@apollo/client';

export const getHostByName = gql`
  query getHostByName($input: GetHostInput) {
    getHost(input: $input) {
      altId
    }
  }
`;
